<script>
    import url from '../../stores/url';
    import Page from './Page.svelte';
    import PopupShareNoteButtonModal from '../PopupShareNoteButtonModal.svelte';
    import PopupPublishNoteButtonModal from '../PopupPublishNoteButtonModal.svelte';
    import LinkedContent from '../../components/LinkedContent/index.svelte';
    import * as storeHelpers from '../../stores/helpers';
    export let markdownSourceList;
    export let savePost;
    export let postUid;
    export let slug;
    export let isPublished;

    export let navigateToNote;

    let sourceMap = {};
    let sourceMapKey = '====';
    let linkedItems = [];
    let linkedNotes = [];

    const headerRule = /\#(.*?)\n/;

    $: {
        sourceMap = markdownSourceList.reduce((acc, sourceItem, currIdx) => {
            if (currIdx === 0) {
                acc['===='] = sourceItem;
                return acc;
            }

            const match = headerRule.exec(sourceItem);

            if (!match) return acc;

            const key = match[1].trim();

            acc[key] = sourceItem;
            return acc;

        }, {});
    }

    $: {
        sourceMapKey = $url.hash?.slice(1) || '====';
        addHashtagKeyToSourceMap(sourceMapKey);
        searchNotesAndItems(sourceMapKey);
    }

    function updateSourceMap(source) {
        sourceMap[sourceMapKey] = source;
    }

    $: finalSource = sourceMap[sourceMapKey]

    function addHashtagKeyToSourceMap(hashtag) {
        if (!(hashtag in sourceMap)) {
            sourceMap[hashtag] = `# ${hashtag} \n\n`
        }
    }

    function getNewPostUid() {
        return $url.pathname.split('/notes/')[1];
    }

    function searchNotesAndItems(hashtag) {
        if (!hashtag.startsWith('#')) {
            hashtag = `#${hashtag}`
        }
        const currentPostUid = getNewPostUid();
        linkedItems = storeHelpers.queryItemsWithTags([hashtag]) || [];
        linkedNotes = (storeHelpers.queryNotesWithTags([hashtag]) || [])
                        .filter(note => note.uuid !== currentPostUid)

        // console.log({
        //     linkedItems,
        //     linkedNotes
        // })
    }

    function convertSourceMapToSourceList() {
        return Object.values(sourceMap).map((sourceItem) => sourceItem);
    }

    const save = () => {
        const sourceList = convertSourceMapToSourceList();
        savePost(sourceList);
    };

    function updateNoteContent() {
        storeHelpers.updateNoteContent(postUid, sourceMap);
    }

</script>

<main>
    <Page
        source={finalSource}
        updateSourceMap={updateSourceMap}
    />

    <button on:click="{save}">save</button>
    <PopupShareNoteButtonModal postUid={postUid} />
    <PopupPublishNoteButtonModal postUid={postUid} slug={slug} isPublished={isPublished} />

    <LinkedContent
        notes={linkedNotes}
        items={linkedItems}
        updateNoteContent={updateNoteContent}
        navigateToNote={navigateToNote}
    />
</main>